import { useMutation } from '@apollo/client';

import { logEvent } from 'features/Analytics/analytics';

import { ToggleTransactionPersonalDocument } from './graphql/toggleTransactionPersonal.gql';

const useToggleTransactionPersonalMutation = (transactionId: string) => {
  const [mutation, hook] = useMutation(ToggleTransactionPersonalDocument);

  const toggleTransactionPersonal = (isPersonal: boolean) =>
    mutation({
      onCompleted: () => {
        logEvent({
          name: `Mark_As_${isPersonal ? 'Professional' : 'Personal'}`,
          properties: { transactionId },
        });
      },
      optimisticResponse: () => ({
        __typename: 'Mutation',
        toggleTransactionHidden: {
          __typename: 'TransactionPayload',
          transaction: {
            __typename: 'Transaction',
            isPersonal,
            transactionId,
            updatedAt: Date.now(),
          },
        },
      }),
      variables: {
        input: {
          isPersonal,
          transactionId,
        },
      },
    });

  return [toggleTransactionPersonal, hook] as const;
};

export default useToggleTransactionPersonalMutation;
